import ApiService from './api.service';
import type { ListRecordsResponse, SingleRecordResponse } from './pipelineNode.service';

export type { ListRecordsResponse };

export interface EllieArtifact {
  id: string;
  user_id: string;
  created_at: string;
  name: string;
  description: string;
  markdown: string;
}

export class EllieArtifactService {
  async find(options?: {
    page?: number;
    pageSize?: number;
  }): Promise<ListRecordsResponse<EllieArtifact>> {
    const {
      page = 1,
      pageSize = 50,
    } = options || {};

    const queryParams: Record<string, any> = {
      page,
      limit: pageSize,
    };

    const result = await ApiService.getInstance().request(
      'GET',
      '/ellieartifacts',
      queryParams
    ) as ListRecordsResponse<EllieArtifact>;

    return result;
  }

  async findById(id: string): Promise<EllieArtifact> {
    const result = await ApiService.getInstance().request(
      'GET',
      `/ellieartifacts/${id}`
    ) as SingleRecordResponse<EllieArtifact>;
    return result.record;
  }

  async delete(id: string): Promise<void> {
    await ApiService.getInstance().request(
      'DELETE',
      `/ellieartifacts/${id}`
    );
  }
}

export const ellieArtifactService = new EllieArtifactService();
